import React from 'react';
import { Modal } from 'porosys-ui';
import './styles.scss';

const deleteConfirmation = props => {
    const { isOpen, onClose, onClickOk } = props;
    return (
        <>
            {isOpen && (
                <Modal
                    classes={{ root: 'modal' }}
                    onClickOk={onClickOk}
                    okText="حذف سند"
                    title="آیا از حذف این سند اطمینان دارید؟"
                    onClose={() => {
                        onClose();
                    }}
                    open={true}
                >
                    <p>شما در حال حذف یک سند از پایگاه داده میباشید، این اقدام قابل برگشت نخواهد بود!</p>
                </Modal>
            )}
        </>
    );
};

export default deleteConfirmation;
